import { localize } from "client_legacy/ndaw/culture";
import { OpenLocalizations } from "./openLocalizations";
import { Anchor, FormattedText } from "client/Components";
import { getAlertManagerOutsideReact } from "client/Hooks";

export function showOpeningInLocalEditorWithOptionToOpenInOnlineEditor(
	openLocalizations: OpenLocalizations,
	hereCallback: () => void
) {
	getAlertManagerOutsideReact()
		.showInfo(
			<FormattedText
				text={localize("_OpeningFileInLocalAppNameAppIfTheLocalAppIsNotAvailableOnYourDeviceClickHereToUseOnlineOfficeApp")}
				thingsToReplace={[
					{ what: "{{LocalAppName}}", filler: openLocalizations.local.app },
					{ what: "{{OnlineAppName}}", filler: openLocalizations.online.app },
					{
						what: "{{Here}}",
						filler: (
							<Anchor onClick={() => hereCallback()}>
								{localize("_Here")}
							</Anchor>
						)
					}
				]}
			/>
		);
}
